import { StationaryRequest } from "../stationary-request";
import { Create } from "../stationary-request/pages/create";
import { Edit } from "../stationary-request/pages/edit";
import { Detail } from "../stationary-request/pages/detail";

export const stationaryRoutes = {
    stationaryRequest: {
      isAdmin: false,
      parentId: "procedure",
      title: "9. Đề nghị văn phòng phẩm",
      path: "/procedure/stationary-request",
      component: StationaryRequest,
    },
    createStationaryRequest: {
      isAdmin: false,
      parentId: "procedure",
      path: "/procedure/stationary-request/create/:id",
      component: Create,
    },
    editStationaryRequest: {
      isAdmin: false,
      parentId: "procedure",
      path: "/procedure/stationary-request/edit/:id",
      component: Edit,
    },
    stationaryRequestDetail: {
      isAdmin: false,
      parentId: "procedure",
      path: "/procedure/stationary-request/detail/:id",
      component: Detail,
    },
  };
  